import SamplesCart from './SamplesCart/SamplesCart';

export default SamplesCart;
